(function () {
	'use strict';

	angular.module('qbePortal').controller('QBRapidEstimateQuotesPanel', QBRapidEstimateQuotesPanel);
	QBRapidEstimateQuotesPanel.$inject = ['$scope', '$state', 'quoteModelFactory', 'labelService', 'portalServiceWrapper', 'userInputRepository', 'serviceResponseRepository', 'MAService', '$timeout', 'quoteOptions', 'gtmService', 'coverTypeResolver', 'quoteResultFilter' , 'storage'];

	function QBRapidEstimateQuotesPanel($scope, $state, quoteModelFactory, labelService, portalServiceWrapper, userInputRepository, serviceResponseRepository, MAService, $timeout, quoteOptions, gtmService, coverTypeResolver, quoteResultFilter, storage) {
		var vm = this,
			quoteHasCoverType = false;

		vm.formData = {};

		var quoteModel = quoteModelFactory.create();

		if (quoteModel.coverType) {
			quoteHasCoverType = true;
		}

		if (quoteHasCoverType) {
			vm.quoteModel = quoteModel.coverType[0];
		}

		$scope.$root.$on('process-rapid-estimates', displayRapidEstimateResults);

		function displayRapidEstimateResults(event, args) {
			var quotesTemp = [];
			vm.formData = args.formData;
			vm.scrollCTA = labelService.getGlobalOptionLabel('rapidEstimate', 'scrollCTA');
			vm.productType = labelService.getGlobalOptionLabel('rapidEstimate', 'productType');
			quoteOptions.clearQuoteResults();
			var mergedQuotes = quoteOptions.getMergedQuoteResults(args.results);
			angular.forEach(mergedQuotes, function (mergedQuote, index) {
				var quote = mergedQuote.getAnnual(),
					monthlyQuote = mergedQuote.getMonthly();

				if (!quote.quoteResult.errors) {
					var offering = quote.offering;
					var coverType = quote.coverType;
					var coverIndicator = offering ? offering : coverType;
					var coverDetails = labelService.getGlobalOption('coverTypes', coverIndicator) ;
					coverDetails.yearlyPayment =  quote.quoteResult.totalPremium;
					coverDetails.monthlyPayment = monthlyQuote.paymentPlan.installment;
					coverDetails.totalPremium = quote.quoteResult.totalPremium;
					coverDetails.offering = offering;
					coverDetails.coverType = coverType;
					coverDetails.coverTypeSubClass = coverDetails.coverTypeSubClass || 'standard' ;
					quotesTemp.push(
						coverDetails
					);
				}
			});

			quotesTemp = quoteResultFilter.filter(window.qbe.rapidEstimateFilter, quotesTemp);
			vm.quotes = quotesTemp;
			$scope.$root.$broadcast('show-rapid-estimates');
			$scope.$root.$broadcast('loading-animation-end');
			animateToResults();
		}

		function animateToResults() {
			$timeout(function () {
				var scrollAnchor = $('qb-rapid-estimate-quotes-panel');
				$('html, body').animate({
					scrollTop: scrollAnchor.offset().top
				}, 'slow');
			}, 100);
		}

		vm.apply = function (quote, paymentFrequency, applyFormPath) {
			$scope.$root.$broadcast('loading-animation-start');
			gtmService.trackEvent('rapid-estimate-apply');
			if (quote.offering)
				quoteOptions.setSelectedOffering(quote.offering);
			else {
				quoteOptions.setSelectedCoverType(quote.coverTypeClass, quote.coverTypeSubClass);
			}

			vm.formData.rapidEstimateUrl = window.location.href;
			userInputRepository.update(vm.formData);
			portalServiceWrapper.updateQuote(vm.formData);
			portalServiceWrapper.saveQuote('everyyear').then(function (resp) {
				performMAServices('apply-now');
				if (!applyFormPath){
					$scope.$emit('rapid-estimate-redirect') ;
				} else {
					storage.setItem('ignoreRapidEstimateRoute' , vm.productType );
					window.location = applyFormPath;
				}
			})
			.catch(function (err) {
				$scope.$root.$broadcast('error', {
					errorMessage: 'Save quote error',
					response: err
				});
			});
		}

		function performMAServices(eventName) {
			var form;
			switch (vm.productType) {
				case 'Car':
					form = vm.formData.vehicleForm;
					break;
				case 'Motorcycle':
					form = vm.formData.bikeForm;
					break;
				case 'Caravan':
					form = vm.formData.caravanForm;
					break;
				case 'Home':
					form = vm.formData.homeForm;
					break;
			}
			var policyEmail = form.tellUsMore ? form.tellUsMore.email : null;
			var campaignCode = form.tellUsMore ? form.tellUsMore.promotionalCode : null;
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom('quote');
			var maData = {
				pageName: 'rapid-estimate',
				campaignCode: campaignCode,
				policyEmail: policyEmail,
				annualResult: quoteResult.getAnnual(),
				monthlyResult: quoteResult.getMonthly(),
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};
			console.log('MA Services called from ' + eventName, maData);
			MAService.mergeContacts(eventName, maData)
		}

		$scope.$root.$broadcast('rapid-estimates-panel-initialised');
	}

	angular.module('qbePortal').component('qbRapidEstimateQuotesPanel', {
		templateUrl: '/ngviews/components/qbRapidEstimateQuotesPanel.html',
		controller: QBRapidEstimateQuotesPanel,
		controllerAs: 'vm',
		bindings: {
			applyFormPath: '@'
		}
	});
})();
